import { render } from "./DateRangePicker.vue?vue&type=template&id=40a3c8a6&scoped=true"
import script from "./DateRangePicker.vue?vue&type=script&lang=js"
export * from "./DateRangePicker.vue?vue&type=script&lang=js"

import "./DateRangePicker.vue?vue&type=style&index=0&id=40a3c8a6&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\HRIS BCK\\digajiin_fe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40a3c8a6"]])

export default __exports__